import { BaseError } from '@infrastructure/axios/error';

export class DomainInvalidPayloadError extends BaseError {
  constructor(code: string, message?: string) {
    super({ code, message: message ?? '', statusCode: 400, error: 'ActiveAccountPayloadError' });
  }
}
